export const MESSAGE_FORM_DEFAULT_VALUES = {
	isNoteOption: true,
	isSMSOption: false,
	isEmailOption: false,
	isLetterOption: false,
	isCPNoteOption: false,
};
